import React from "react";
import { Link } from "react-router-dom";
import { Building2, Plus, Sparkles } from "lucide-react";
import { CREATE_BET_HOUSE_PATH } from "../../utils/createBetHouseHelpers";
import { OPERATOR_NAV_CATEGORIES, getOperatorSection } from "../../utils/operatorConsoleHelpers";

const OperatorNoHousePanel = () => (
  <section className="oc-panel oc-no-house">
    <header className="oc-panel-head">
      <p className="oc-no-house-eyebrow">
        <Sparkles size={13} aria-hidden />
        Operator desk
      </p>
      <h2>Create your first house</h2>
      <p>
        Treasury, fixtures, bettors, and live pulse unlock once you launch a
        betting house. The console stays here — your market data will fill in
        after setup.
      </p>
    </header>

    <div className="oc-no-house-actions">
      <Link to={CREATE_BET_HOUSE_PATH} className="oc-create-house-btn oc-create-house-btn-lg">
        <Plus size={16} strokeWidth={2.25} aria-hidden />
        <span>Create a house</span>
      </Link>
      <Link to="/app/bethouse" className="oc-no-house-secondary">
        Browse Bet House
      </Link>
    </div>

    <div className="oc-no-house-preview" aria-hidden>
      <p className="oc-no-house-preview-label">Unlocks after launch</p>
      <ul>
        {OPERATOR_NAV_CATEGORIES.flatMap((category) =>
          category.sectionIds.map((sectionId) => {
            const section = getOperatorSection(sectionId);
            if (!section || sectionId === "pulse") return null;
            return (
              <li key={sectionId}>
                <Building2 size={12} />
                <span>{section.label}</span>
                <em>{section.hint}</em>
              </li>
            );
          })
        ).filter(Boolean)}
      </ul>
    </div>
  </section>
);

export default OperatorNoHousePanel;
